<div class="container pricing-container" [dir]="language=='ar' ? 'rtl' : 'ltr'">
  <div *ngFor="let department of departments; let last = last">
    <h3>
      <span
        *ngFor="
          let word of department.departmentName.split(' ');
          let isLast = last
        "
      >
        <span *ngIf="!isLast">{{ word }} </span>
        <span *ngIf="isLast" class="last-word">{{ word }}</span>
      </span>
    </h3>

    <div class="d-flex cards-container">
      <div
        class="card"
        *ngFor="let item of department.pricing; let last = last"
      >
        <div class="col">
          <app-pricing-card
            [packageName]="item.packageName"
            [packagePrice]="item.packagePrice"
            [packageShowPrice]="item.showPrice"
            [packageServices]="item.packageServices"
          ></app-pricing-card>
        </div>
      </div>
    </div>
  </div>
</div>
